export const VUEX_CATEGORY_BROWSER_UPDATE_QUERY = 'VUEX_CATEGORY_BROWSER_UPDATE_QUERY'
export const VUEX_CATEGORY_BROWSER_UPDATE_STATE_FROM_QUERY = 'VUEX_CATEGORY_BROWSER_UPDATE_STATE_FROM_QUERY'
